const LOCK_KEY_PREFIX = 'hris-submit-inflight:'

// Long enough to cover realistic file-processing time, short enough that a
// crashed/abandoned tab doesn't block a legitimate resubmit indefinitely.
const LOCK_TTL_MS = 3 * 60 * 1000

function lockKey(fileId: string): string {
  return `${LOCK_KEY_PREFIX}${fileId}`
}

// localStorage is shared across every tab of the same origin and survives a
// full page reload — unlike React state, which is per-tab and wiped by any
// remount. This is what actually closes the two-tab / reload-then-resubmit
// race: both tabs (or a tab before/after reload) consult the same lock.
export function isSubmitLocked(fileId: string): boolean {
  try {
    const raw = window.localStorage.getItem(lockKey(fileId))
    if (!raw) return false

    const startedAt = Number(raw)
    if (!Number.isFinite(startedAt)) {
      window.localStorage.removeItem(lockKey(fileId))
      return false
    }

    if (Date.now() - startedAt > LOCK_TTL_MS) {
      window.localStorage.removeItem(lockKey(fileId))
      return false
    }

    return true
  } catch {
    // Storage unavailable (eg. Safari private browsing) — fail open rather
    // than block submission entirely.
    return false
  }
}

export function acquireSubmitLock(fileId: string): void {
  try {
    window.localStorage.setItem(lockKey(fileId), String(Date.now()))
  } catch {
    // Ignore — see isSubmitLocked.
  }
}

export function releaseSubmitLock(fileId: string): void {
  try {
    window.localStorage.removeItem(lockKey(fileId))
  } catch {
    // Ignore — see isSubmitLocked.
  }
}
